import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { triggerFocus } from 'antd/lib/input/Input';
import { PlantMappersState } from 'types';

export const initialState: PlantMappersState = {
  loading: false,
  plantMappersList: [],
  reset: false,
  filter: {
    manufacture: '',
    distributor: ''
  }
};

const slice = createSlice({
  name: 'Plant Mappers',
  initialState,
  reducers: {
    setPlantMapperList: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.plantMappersList = payload || [];
      state.reset = false;
    },
    reset: (state) => {
      state.reset = true;
    },
    setFilter: (state, { payload }: PayloadAction<any>) => {
      const filter = { ...payload };

      state.filter = { ...state.filter, ...filter };
    }
  }
});

export const { setPlantMapperList, reset, setFilter } = slice.actions;

export default slice.reducer;
